/// <reference path="../../../../rcwebmodels/reeferformatter.cs.d.ts" />
import { fetch, addTask } from 'domain-task';
import { Action, Reducer, ActionCreator } from 'redux';
import { AppThunkAction } from './';

import { RCUtils } from './../RCUtils';
import { PopupWindow } from '../components/sharedcomponents/PopupWindow';
import { getStateToken } from '@okta/okta-auth-js';
import { data } from 'jquery';
var Config: any = require('../Config.json');
// -----------------
// STATE - This defines the type of data maintained in the Redux store.
export interface RcdSearchState {
    isLoading: boolean;
    rcdSearchFilters: server.RcdStatusSearchFilters;
    rcdStatus: server.USP_RcdCurrentConditionUI[];
    reeferFormatter: server.ReeferFormatter;
    refApplicationParams: any;
    SelectedRowGroups: [];
}

// -----------------
// ACTIONS - These are serializable (hence replayable) descriptions of state transitions.
// They do not themselves have any side-effects; they just describe something that is going to happen.

interface RequestRcdSearchAction {
    type: 'REQUEST_RCD_ADVANCE_SEARCH';
    rcdSearchFilters: server.RcdStatusSearchFilters;
}

interface ReceiveRcdSearchAction {
    type: 'RECEIVE_RCD_ADVANCE_SEARCH_DETAILS';
    rcdSearchFilters: server.RcdStatusSearchFilters;
    rcdStatusData: server.USP_RcdCurrentConditionUI[];
}
interface RequestEventMaster {
    type: 'REQUEST_EVENTMASTER';
}
interface ReceiveEventMaster {
    type: 'RECEIVE_EVENTMASTER';
    reeferFormatterData: server.ReeferFormatter;
}

interface RequestRefApplicationParams {
    type: 'REQUEST_REF_APPLICATION_PARAMS';
}

interface ReceiveRefApplicationParams {
    type: 'RECEIVE_REF_APPLICATION_PARAMS';
    refApplicationParams: any;
}
interface REQUEST_TOHOLD_SELECTEDROWGROUPS {
    type: 'REQUEST_TOHOLD_SELECTEDROWGROUPS';
    selectedRowGroups :[]

}
// Declare a 'discriminated union' type. This guarantees that all references to 'type' properties contain one of the
// declared type strings (and not any other arbitrary string).
type KnownAction = RequestRcdSearchAction | ReceiveRcdSearchAction | RequestEventMaster | ReceiveEventMaster | RequestRefApplicationParams | ReceiveRefApplicationParams | REQUEST_TOHOLD_SELECTEDROWGROUPS;

// ----------------
// ACTION CREATORS - These are functions exposed to UI components that will trigger a state transition.
// They don't directly mutate state, but they can have external side-effects (such as loading data).

export const actionCreators = {
    requestRcdAdvanceSearch: (rcdSearchFilters: server.RcdStatusSearchFilters): AppThunkAction<KnownAction> => (dispatch, getState) => {
        // Only load data if it's something we don't already have (and are not already loading)
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/RcdStatus/RcdStatusSearchDataSP', { method: 'POST', body: JSON.stringify(rcdSearchFilters), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } })
        let fetchTask = fetch(request)
            .then(RCUtils.handleError)        
            .then(response => response.json() as Promise<server.USP_RcdCurrentConditionUI[]>)
            .then(data => {               
                if (data.length > 0) {           
                    if (data[0].ErrorMessage == null || data[0].ErrorMessage == "") {
                        dispatch({ type: 'RECEIVE_RCD_ADVANCE_SEARCH_DETAILS', rcdSearchFilters: rcdSearchFilters, rcdStatusData: data });
                        if (data[0].CountMessage == "Show")
                            PopupWindow.showErrorMessage("Refine Search!", "The maximum search limit has been reached. Please filter you search criteria.");
                    }
                    else {
                        dispatch({ type: 'RECEIVE_RCD_ADVANCE_SEARCH_DETAILS', rcdSearchFilters: rcdSearchFilters, rcdStatusData: [] });
                        PopupWindow.showErrorMessage("Refine Search!", "Your search returns too many results. Please refine your search.");
                    }
                }
                else
                    dispatch({ type: 'RECEIVE_RCD_ADVANCE_SEARCH_DETAILS', rcdSearchFilters: rcdSearchFilters, rcdStatusData: [] });

                $('#globalLoader').hide();
            });

        addTask(fetchTask); // Ensure server-side prerendering waits for this to complete
        dispatch({ type: 'REQUEST_RCD_ADVANCE_SEARCH', rcdSearchFilters: rcdSearchFilters });
    },
    requestEventMaster: (): AppThunkAction<KnownAction> => (dispatch, getState) => {
        // Only load data if it's something we don't already have (and are not already loading)      
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/common/GetReeferFormattersList', { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } })
        let fetchTask = fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.ReeferFormatter>)
            .then(data => {
                dispatch({ type: 'RECEIVE_EVENTMASTER', reeferFormatterData: data });
            });

        addTask(fetchTask); // Ensure server-side prerendering waits for this to complete
        dispatch({ type: 'REQUEST_EVENTMASTER' });
    },
    requestRefApplicationParams: (): AppThunkAction<KnownAction> => (dispatch, getState) => {
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/common/GetRefApplicationParams', { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } })
        let fetchTask = fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any>)
            .then(data => {
                dispatch({ type: 'RECEIVE_REF_APPLICATION_PARAMS', refApplicationParams: data });
            });

        addTask(fetchTask); // Ensure server-side prerendering waits for this to complete
        dispatch({ type: 'REQUEST_REF_APPLICATION_PARAMS' });
    },
    requestToHoldSelectedRowGroups: (SelectedRowGroups: []): AppThunkAction<KnownAction> => (dispatch, getState) => {
        dispatch({ type: 'REQUEST_TOHOLD_SELECTEDROWGROUPS', selectedRowGroups : SelectedRowGroups });
    }
};

// ----------------
// REDUCER - For a given state and action, returns the new state. To support time travel, this must not mutate the old state.
const emptySearchFilter = { SelectedRcd: null, SelectedCountry: null, SelectedInterval: null, SelectedGeofenceInside: null, SelectedGeofence: null, SelectedICCID: null, SelectedMSISDN: null, AllRcds: null, SelectedAssetType: null }
const unloadedState: RcdSearchState = { isLoading: false, rcdSearchFilters: emptySearchFilter, rcdStatus: [], reeferFormatter: null, refApplicationParams: null,SelectedRowGroups:[] };

export const reducer: Reducer<RcdSearchState> = (state: RcdSearchState, incomingAction: Action) => {
    const action = incomingAction as KnownAction;
    switch (action.type) {
        case 'REQUEST_RCD_ADVANCE_SEARCH':
            return {
                rcdSearchFilters: action.rcdSearchFilters,
                rcdStatus: state.rcdStatus,
                reeferFormatter: state.reeferFormatter,
                isLoading: true,
                refApplicationParams: state.refApplicationParams,
                SelectedRowGroups: state.SelectedRowGroups

            };
        case 'REQUEST_EVENTMASTER':
            return {
                rcdSearchFilters: state.rcdSearchFilters,
                rcdStatus: state.rcdStatus,
                reeferFormatter: state.reeferFormatter,
                isLoading: true,
                refApplicationParams: state.refApplicationParams,
                SelectedRowGroups: state.SelectedRowGroups
            };
        case 'RECEIVE_EVENTMASTER':
            return {
                rcdSearchFilters: state.rcdSearchFilters,
                rcdStatus: state.rcdStatus,
                reeferFormatter: action.reeferFormatterData,
                isLoading: false,
                refApplicationParams: state.refApplicationParams,
                SelectedRowGroups: state.SelectedRowGroups

            };
        case 'REQUEST_REF_APPLICATION_PARAMS':
            return {
                rcdSearchFilters: state.rcdSearchFilters,
                rcdStatus: state.rcdStatus,
                reeferFormatter: state.reeferFormatter,
                isLoading: true,
                refApplicationParams: state.refApplicationParams,
                SelectedRowGroups: state.SelectedRowGroups
            };
        case 'RECEIVE_REF_APPLICATION_PARAMS':
            return {
                rcdSearchFilters: state.rcdSearchFilters,
                rcdStatus: state.rcdStatus,
                reeferFormatter: state.reeferFormatter,
                isLoading: false,
                refApplicationParams: action.refApplicationParams,
                SelectedRowGroups: state.SelectedRowGroups

            };
        case 'RECEIVE_RCD_ADVANCE_SEARCH_DETAILS':
            // Only accept the incoming data if it matches the most recent request. This ensures we correctly
            // handle out-of-order responses.
            if (action.rcdSearchFilters === state.rcdSearchFilters) {
                return {
                    rcdSearchFilters: action.rcdSearchFilters,
                    rcdStatus: action.rcdStatusData,
                    reeferFormatter: state.reeferFormatter,
                    isLoading: false,
                    refApplicationParams: state.refApplicationParams,
                    SelectedRowGroups: state.SelectedRowGroups
                };
            }
            break;
        case 'REQUEST_TOHOLD_SELECTEDROWGROUPS':
            return {
                rcdSearchFilters: state.rcdSearchFilters,
                rcdStatus: state.rcdStatus,
                reeferFormatter: state.reeferFormatter,
                isLoading: false,
                refApplicationParams: state.refApplicationParams,
                SelectedRowGroups: action.selectedRowGroups
            };            
            break;
        default:
            // The following line guarantees that every action in the KnownAction union has been covered by a case above
            const exhaustiveCheck: never = action;
    }

    return state || unloadedState;
};
